import apiClient from './api';

export interface MeituanReservationChangeLog {
  id: string;
  callbackId: string;
  messageType: string;
  meituanOrderId: string;
  serviceOrderId: string;
  serviceOrderNo: string;
  shopId: string;
  opBizCode: string;
  businessId: string;
  productId: string;
  productName: string;
  reserveBeginTime: string;
  reserveEndTime: string;
  userAddress: string;
  userName: string;
  reserveMobile: string;
  reservePhone: string;
  autoConfirmChange: number;
  processStatus: number;
  processMessage: string;
  rawPayload?: unknown;
  createdAt: string;
  updatedAt: string;
}

export interface MeituanReservationOrderLog {
  id: string;
  meituanOrderId: string;
  appOrderId: string;
  serviceOrderId: string;
  serviceOrderNo: string;
  callbackId: string;
  businessId: string;
  appProductId: string;
  productId: string;
  productName: string;
  beginTime: string;
  endTime: string;
  duration: string;
  userName: string;
  userAddress: string;
  mobile: string;
  phone: string;
  quantity: string;
  amount: string;
  comment: string;
  orderRemark: string;
  processStatus: number;
  processMessage: string;
  rawPayload?: unknown;
  createdAt: string;
  updatedAt: string;
}

export interface MeituanReservationChangeLogListParams {
  page?: number;
  pageSize?: number;
  serviceOrderNo?: string;
  meituanOrderId?: string;
  productName?: string;
  userName?: string;
  messageType?: string;
  processStatus?: string;
  startTime?: string;
  endTime?: string;
}

export interface MeituanReservationOrderLogListParams {
  page?: number;
  pageSize?: number;
  serviceOrderNo?: string;
  meituanOrderId?: string;
  appOrderId?: string;
  appProductId?: string;
  productName?: string;
  userName?: string;
  mobile?: string;
  processStatus?: string;
  startTime?: string;
  endTime?: string;
}

export const listMeituanReservationChangeLogs = (params: MeituanReservationChangeLogListParams) => (
  apiClient.get<{ list: MeituanReservationChangeLog[]; total: number; page: number; pageSize: number }>(
    '/meituan/reservation-change-logs',
    { params },
  )
);

export const listMeituanReservationOrderLogs = (params: MeituanReservationOrderLogListParams) => (
  apiClient.get<{ list: MeituanReservationOrderLog[]; total: number; page: number; pageSize: number }>(
    '/meituan/reservation-order-logs',
    { params },
  )
);
export interface RecoverMeituanReservationOrderResponse {
  callbackId: string;
  meituanOrderId: string;
  appOrderId: string;
  serviceOrderId: string;
  serviceOrderNo: string;
  processStatus: number;
  processMessage: string;
}

export const recoverMeituanReservationOrder = (meituanOrderId: string) => (
  apiClient.post<RecoverMeituanReservationOrderResponse>('/meituan/reservation-order/recover', { meituanOrderId })
);
